// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import LoginHeader from '../../../molecules/LoginHeader';
import EmailForm from '../../../molecules/EmailForm';
import styles from './styles/ LoginEmailSection.styles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
} from '../../../../../../../utils/labels/globalLogin.labels';

class LoginEmailSection extends React.PureComponent {
  render() {
    const {
      onSubmit,
      formErrorMessage,
      loginErrorMessage,
      initialValues,
      showEmailRecaptcha,
      resetForm,
      className,
      variation,
      resetLoginState,
      isLoading,
      closeOverlay,
      isResetPassCodeValidationEnabled,
      closeModal,
      fullPage,
      setUserEmailAddress,
      backToBag,
      isV2Flow,
    } = this.props;
    const {
      lbl_login_back_to_bag_label: lblLoginBackToBag,
      lbl_login_checkout: lblLoginCheckout,
      lbl_login_checkout_email: lblLoginCheckoutEmail,
      lbl_login_or_checkout_guest_label: lblLoginOrCheckoutGuest,
      lbl_login_or_checkout_guest_label_sub_heading: lblLoginOrCheckoutGuestSubHeading,
    } = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);

    return (
      <div className={className}>
        <div className="top-section-container">
          <LoginHeader
            variation={isV2Flow ? 'checkout' : variation}
            fullPage={fullPage}
            headingLabel={lblLoginCheckout}
            subHeadingLabel={
              isV2Flow
                ? renderLabel(lblLoginOrCheckoutGuest, 'lbl_login_or_checkout_guest_label')
                : lblLoginCheckoutEmail
            }
            subHeadingLabel2={
              isV2Flow
                ? renderLabel(
                    lblLoginOrCheckoutGuestSubHeading,
                    'lbl_login_or_checkout_guest_label_sub_heading'
                  )
                : lblLoginCheckoutEmail
            }
          />
          {isV2Flow && <BodyCopy component="div" textAlign="center" className="underline" />}
        </div>
        <Row>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: `${variation === 'checkout' ? 7 : 12}`,
            }}
            className={`elem-pt-SM ${variation === 'checkout' ? 'checkoutForm' : 'loginForm'}`}
          >
            <React.Fragment>
              <EmailForm
                onSubmit={onSubmit}
                formErrorMessage={formErrorMessage}
                loginErrorMessage={loginErrorMessage}
                initialValues={initialValues}
                showRecaptcha={showEmailRecaptcha}
                resetForm={resetForm}
                className="elem-mb-LRG"
                onCreateAccountClick={this.showCreateAccountForm}
                variation={variation}
                resetLoginState={resetLoginState}
                isLoading={isLoading}
                closeOverlay={closeOverlay}
                closeModal={closeModal}
                isResetPassCodeValidationEnabled={isResetPassCodeValidationEnabled}
                fullPage={fullPage}
                setUserEmailAddress={setUserEmailAddress}
              />
            </React.Fragment>
          </Col>
        </Row>
        <div className="back-bag-cont">
          <BodyCopy
            component="div"
            textAlign="center"
            fontSize="fs14"
            onMouseDown={(e) => backToBag(e, 'fromEmail')}
            className="elem-mt-MED_2 back-bag"
          >
            {lblLoginBackToBag}
          </BodyCopy>
        </div>
      </div>
    );
  }
}

LoginEmailSection.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  labels: PropTypes.shape({}).isRequired,
  loginErrorMessage: PropTypes.string,
  initialValues: PropTypes.shape({}).isRequired,
  setUserEmailAddress: PropTypes.func,
  queryParams: PropTypes.shape({}).isRequired,
  formErrorMessage: PropTypes.shape({}).isRequired,
  backToBag: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  resetForm: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  variation: PropTypes.string.isRequired,
  resetLoginState: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  closeOverlay: PropTypes.func,
  isResetPassCodeValidationEnabled: PropTypes.bool,
  fullPage: PropTypes.bool,
  showEmailRecaptcha: PropTypes.bool,
  isV2Flow: PropTypes.bool,
};

LoginEmailSection.defaultProps = {
  loginErrorMessage: '',
  setUserEmailAddress: () => {},
  closeOverlay: () => {},
  isResetPassCodeValidationEnabled: false,
  fullPage: false,
  showEmailRecaptcha: false,
  isV2Flow: false,
};

export default withStyles(LoginEmailSection, styles);
export { LoginEmailSection as LoginEmailSectionVanilla };
